import React, {PureComponent} from "react";
import {required} from "./Validation";
import {Field, reduxForm} from "redux-form";
import SelectField from "../../../../core/components/forms/SelectField";
import {connect} from "react-redux";
import ModalButton from "../../../../core/components/modals/ModalButton";
import FileButton from "../../buttons/FileButton";
import UrlButton from "../../buttons/UrlButton";
import {withTranslation, Trans} from "react-i18next";
import {scrollToFirstError} from '../../helpers/ScrollToFirstErrorHelper'
import Faq from "./inc/Faq";

class OrderFormLandingPage extends PureComponent {

    render() {
        const { services, t } = this.props;

        return <div className="main">
            <h1>{t('Order transcriptions')}</h1>
            <span className="info">{t('Professionals transcribe your files to 99% accuracy')}</span>
            <div className="main-holder">
                <div className="content">
                    <div>
                        <span className="label inner">
                            {t('Services')}
                            <span className="info-holder">
                                {t('info')}
                                <span className="popup">
                                    {t('This is the place to claim your goods. Enter the promo code in the section to the' +
                                        ' right and your free virtual good will be automatically added to your Roblox account.')}
                                </span>
                            </span>
                        </span>
                        <div className="row custom-select">
                            <Field
                                name="service"
                                component={SelectField}
                                validate={[required]}
                                options={services}
                            />
                        </div>
                    </div>
                    <div className="mobile-hidden">
                        <div className="blocks">
                            <div className="block">
                                <ModalButton id="file-modal-component" className="download upload-file-icon" />
                                <span className="title">Upload files from your computer or drag and drop</span>
                                <ModalButton id="file-modal-component" className="btn blue">Upload files</ModalButton>
                            </div>
                            <span className="or">Or</span>
                            <div className="block">
                                <ModalButton id="url-modal-component" className="download link add-url-icon" />
                                <span className="title">Share a link to a public address</span>
                                <ModalButton id="url-modal-component" className="btn pink">Add url</ModalButton>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-visible">
                        <div className="blocks">
                            <div className="block">
                                <span className="download" />
                                <span className="title">{t('Upload files from your computer or drag and drop')}</span>
                                <FileButton className="btn blue">{t('Upload files')}</FileButton>
                            </div>
                            <span className="or">{t('Or')}</span>
                            <div className="block">
                                <a href="#" className="download link" />
                                <span className="title">{t('Share a link to a public address')}</span>
                                <UrlButton className="btn pink">{t('Add url')}</UrlButton>
                            </div>
                        </div>
                    </div>
                </div>
                <aside id="sidebar">
                    <div className="box">
                        <div className="title-holder">
                            <span className="title">{t('Support')}</span>
                        </div>
                        <span className="inform">{t('Please click the button below to contact Support Team')}</span>
                        <a href="#" className="btn style01">{t('LIVE CHAT')}</a>
                    </div>
                    <Faq />
                </aside>
            </div>
        </div>
    }
}

OrderFormLandingPage = withTranslation()(OrderFormLandingPage);

OrderFormLandingPage = reduxForm({
    form: 'OrderForm',
    enableReinitialize: true,
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    onSubmitFail: (errors) => scrollToFirstError(errors),
})(OrderFormLandingPage)

export default connect(
    state => ({
        services: state.dictionary.service,
    })
)(OrderFormLandingPage)